import { Field } from 'formik'
import React from 'react'

import { Subsection } from '@fourthwall/components'
import { TimezoneSelect } from '@modules/Timezone/components/TimezoneSelect'

export const Timezone = () => {
  return (
    <Subsection title="Time zone">
      <Field component={TimezoneSelect} name="timezone" label="Time zone" />
    </Subsection>
  )
}
